import React from 'react';
import { useHistory } from 'react-router-dom';

import { AccessContentModal } from 'Components/AccessContentModal';
import { useConfig } from 'Context/ConfigContext';
import { getAppUIVariantConfig } from 'Util/uiVariantSet';

const CourseExpiredModal = ({ isActive, onContinue }) => {
  const { Modal } = getAppUIVariantConfig();
  const history = useHistory();
  const { landingRoute = '/my-courses' } = useConfig();

  const handleGoToLandingPage = () => {
    if (typeof onContinue === 'function') return onContinue();
    return history.replace(landingRoute);
  };

  switch (Modal) {
    case 'Rounded':
    default: {
      return <AccessContentModal muiProps={{ isActive }} onClick={handleGoToLandingPage} />;
    }
  }
};

export default CourseExpiredModal;
